import { render, staticRenderFns } from "./workView.vue?vue&type=template&id=aecd8222&scoped=true"
import script from "./workView.vue?vue&type=script&lang=js"
export * from "./workView.vue?vue&type=script&lang=js"
import style0 from "./workView.vue?vue&type=style&index=0&id=aecd8222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecd8222",
  null
  
)

export default component.exports